import { render, staticRenderFns } from "./study-certificate.vue?vue&type=template&id=18b9482c&scoped=true&"
import script from "./study-certificate.vue?vue&type=script&lang=js&"
export * from "./study-certificate.vue?vue&type=script&lang=js&"
import style0 from "./study-certificate.vue?vue&type=style&index=0&id=18b9482c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b9482c",
  null
  
)

export default component.exports